import { Chip } from "@legal-500/legal500-design-system";
import type { AwardState } from "../../../api/awards.types.js";
import styles from "./AwardsCells.module.css";

const PUBLISH_STATE_LABELS: Record<AwardState, string> = {
  published: "Published",
  draft: "Draft",
};

const PUBLISH_STATE_CLASS_NAMES: Record<AwardState, string> = {
  published: styles.publishStatusPublished,
  draft: styles.publishStatusDraft,
};

type PublishStatusChipProps = {
  state: AwardState;
};

/**
 * Publish state, as a chip with a leading coloured dot: green for published,
 * grey for draft.
 *
 * The dot is a `<span>` *inside* the chip because `ChipProps` is a closed type
 * with no rest-spread — `style`, `data-*` and `aria-*` on `Chip` do not compile.
 * Its colour rides in on a custom property the chip's own class sets, so the
 * light and dark palettes stay together in one place in the stylesheet.
 */
export function PublishStatusChip({ state }: PublishStatusChipProps) {
  return (
    <Chip size="small" variant="filled" className={PUBLISH_STATE_CLASS_NAMES[state]}>
      <span className={styles.publishStatusLabel}>
        <span className={styles.publishStatusDot} aria-hidden="true" />
        {PUBLISH_STATE_LABELS[state]}
      </span>
    </Chip>
  );
}
